module.exports = __webpack_public_path__ + "static/img/wen-chang-jin.3a4e033.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wen-chang-jin.jpeg
// module id = AGts
// module chunks = 1